/* tslint:disable */
/* eslint-disable */
/**
 * Famifarm-API
 * Famifarm API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalizedValue,
    LocalizedValueFromJSON,
    LocalizedValueFromJSONTyped,
    LocalizedValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface Pest
 */
export interface Pest {
    /**
     * 
     * @type {string}
     * @memberof Pest
     */
    id?: string;
    /**
     * 
     * @type {Array<LocalizedValue>}
     * @memberof Pest
     */
    name?: Array<LocalizedValue>;
}

export function PestFromJSON(json: any): Pest {
    return PestFromJSONTyped(json, false);
}

export function PestFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : ((json['name'] as Array<any>).map(LocalizedValueFromJSON)),
    };
}

export function PestToJSON(value?: Pest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name === undefined ? undefined : ((value.name as Array<any>).map(LocalizedValueToJSON)),
    };
}


